var map = {
	"./analysis.svg": "385d",
	"./angle-down.svg": "b717",
	"./angle-left.svg": "ac26",
	"./angle-right.svg": "d97f",
	"./angle-up.svg": "71f4",
	"./attention.svg": "98eb",
	"./buildings.svg": "1d8b",
	"./categories/balcony.svg": "aac7",
	"./categories/ceiling.svg": "97a4",
	"./categories/chimney.svg": "e2a4",
	"./categories/exterior-tiles.svg": "1c2e",
	"./categories/facade.svg": "1050",
	"./categories/floor.svg": "0655",
	"./categories/gutters.svg": "3869",
	"./categories/installations.svg": "b47e",
	"./categories/insulation.svg": "b63c",
	"./categories/interior-tiles.svg": "0204",
	"./categories/plinth.svg": "6a7d",
	"./categories/roof.svg": "139a",
	"./categories/soft-joints.svg": "b1e6",
	"./categories/sole-benches.svg": "6a77",
	"./categories/stairs.svg": "f72c",
	"./categories/walls.svg": "9223",
	"./categories/window.svg": "5da3",
	"./categories/woodwork.svg": "8c35",
	"./checkmark.svg": "ca3f",
	"./close.svg": "bb7c",
	"./cross.svg": "3a4d",
	"./download.svg": "8215",
	"./dropdown.svg": "77bb",
	"./external-link.svg": "e3e6",
	"./feedback.svg": "784f",
	"./file-img.svg": "062e",
	"./file-pdf.svg": "4d9a",
	"./filter.svg": "bcee",
	"./fractions.svg": "de5d",
	"./house.svg": "b1ac",
	"./image-placeholder.svg": "a623",
	"./info.svg": "69d9",
	"./menu-hide.svg": "2ad3",
	"./minus.svg": "2aeb",
	"./paradigm.svg": "9b61",
	"./plus.svg": "4eb1",
	"./question.svg": "22e2",
	"./remediation.svg": "629a",
	"./resale.svg": "81ac",
	"./rotate-right.svg": "668f",
	"./star.svg": "ec6f",
	"./text.svg": "e447",
	"./types.svg": "e5cc",
	"./video-small-2.svg": "a33a",
	"./zoom-in.svg": "64d0",
	"./zoom-out.svg": "e29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";